<template>
    <div v-if="isloaded" class="details-gallery-container position-relative user-select-none">
        <swiper class="swiper swiper-index" :options="swiperOption">
            <swiper-slide v-if="video_link && video_link != '' && video_link.includes('youtube.com') && video_link.includes('embed')">
                <div  @click="showVideo" style="background: black; position: absolute; top: 0; left: 0; right: 0; bottom: 0; opacity: 0;"></div>
                <iframe style="height:100%; width: 800px; pointer-events:none;" :src="video_link" frameborder="0" allowfullscreen></iframe>
            </swiper-slide>
            <swiper-slide v-for="(image, ind) in images" :key="ind">
                <img :src="image" @click="index=ind" style="height:100%;cursor:pointer;object-fit:cover;">
            </swiper-slide>
            <div class="swiper-button-prev db-mn" slot="button-prev"></div>
            <div class="swiper-button-next db-mn" slot="button-next"></div>
            <div class="swiper-pagination" slot="pagination"></div>
        </swiper>
        <!-- <div class="swiper-pagination">{{ images.length }} Photos <span v-if="video_link && video_link != '' && video_link.includes('youtube.com') && video_link.includes('embed')">&amp; 1 Video</span></div> -->
        <Tinybox :images="images" :index="index" @change="(i) => {index = i}" loop />
        <modal name="youtube-embed-modal" width="80%" height="auto">
            <div slot="top-right">
                <button @click="hideVideo" class="video-modal-xbtn">✕</button>
            </div>
            <div class="video-container">
                <iframe v-if="video_link && video_link != '' && video_link.includes('youtube.com') && video_link.includes('embed')" :src="video_link" class="yt-video" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture; fullscreen" allowfullscreen></iframe>
            </div>
        </modal>
    </div>
</template>

<script>
    import Tinybox from "vue-tinybox";
    import { Swiper, SwiperSlide } from 'vue-awesome-swiper'
    import 'swiper/css/swiper.css'

    export default {
        name: 'image-lightbox',
        title: 'Image-Lightbox',
        components: {
            Tinybox,
            Swiper,
            SwiperSlide
        },
        props: ['featured','public','video'],
        data() {
            return {
                index: null,
                images: null,
                isloaded: false,
                video_link: null,
                swiperOption: {
                    slidesPerView: 'auto',
                    spaceBetween: 10,
                    pagination: {
                        el: '.swiper-pagination',
                        type: 'fraction'
                    },
                    navigation: {
                        nextEl: '.swiper-button-next',
                        prevEl: '.swiper-button-prev',
                        disabledClass: 'swiper-none'
                    }
                }
            }
        },
        mounted() {
            let result = this.public.map(a => a.name.large.url);
            result.unshift(this.featured)
            this.images = result;
            this.isloaded = true;

            var url = this.video;
            if (url) {
                url = url.replace("m.youtube.com", "www.youtube.com");
                url = url.replace(
                    "https://youtu.be/",
                    "https://www.youtube.com/embed/"
                );
                url = url.replace("watch?v=", "embed/");
                url = url.split("&list=")[0];
                this.video_link = url;
            }
        },
        methods: {
            showVideo () {
                this.$modal.show('youtube-embed-modal');
            },
            hideVideo () {
                this.$modal.hide('youtube-embed-modal');
            }
        }

    }
</script>

<style scoped>
    .swiper-button-next, .swiper-button-prev {
        color: #FF0000 !important;
        background: rgba(21, 21, 21, 0.9);
        height: 46px;
        width: 46px;
        top: auto;
        bottom: 25px;
        border: 8px solid rgba(21, 21, 21, 0.9);
    }

    .swiper-button-next:after, .swiper-button-prev:after {
        font-size: 14px !important;
        background: white;
        width: 30px;
        height: 30px;
        display: flex;
        justify-content: center;
        align-items: center;
        border-radius: 50%;
    }

    .swiper-button-prev { 
        left: auto !important; 
        right: 190px;
        border-radius: 50% 0 0 50%;
    }

    .swiper-button-next { 
        right: 30px !important;
        border-radius: 0 50% 50% 0;
    }

    .details-gallery-container, .swiper { 
        height: 500px;
    }

    .swiper-slide {  width: auto !important; }

    .swiper-none.swiper-button-next:after, .swiper-none.swiper-button-prev:after {
        background: rgba(255, 255, 255, 0.6) !important;
    }
        
    .swiper-pagination {
        padding: 10px 15px; 
        display: flex;
        justify-content: center;
        align-items: center;
        left: auto;
        right: 70px;
        bottom: 25px;
        height: 46px;
        width: 120px;
        background: rgba(21, 21, 21, 0.9);
        cursor: pointer;
        color: #FFFFFF;
    }

    .swiper-index {
        z-index: 1;
    }

    @media (max-width: 991px) {
        .swiper-pagination {
            padding: 7px 20px;
            right: auto;
            left: 15px;
            bottom: 15px;
            height: auto;
            width: auto;
            background: rgba(255, 255, 255, 0.47);
            border-radius: 20px;
        }

        .details-gallery-container, .swiper { 
            height: 400px;
        }
    }
</style>